import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import AtlasV2TotalTrafficDonutChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficDonutChart';
import { useDorisSummary } from 'src/serverProxy/useDorisSummary';
import { TrafficBarCharts } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/TrafficBarCharts';

export interface AtlasV2TrafficTopSectionV2Props {
  externalContainerRef?: React.RefObject<HTMLDivElement>;
}

/**
 * Shows donut chart and bar charts for the top section of Total Traffic
 */
export const AtlasV2TrafficTopSectionV2 = ({ externalContainerRef }: AtlasV2TrafficTopSectionV2Props = {}) => {
  const {
    primaryData,
    isLoading: isPrimaryLoading,
    comparisonData,
    isLoading
  } = useDorisSummary({
    requestName: 'total-traffic-top-section',
    metricType: 'ClicksSummary',
    retailerId: 1
  });

  return (
    <Flex justifyContent="space-between" alignItems="center">
      {/* TODO:: If we deprecate traffic v1, the marginTop should be removed and moved to the actual donut chart*/}
      <div style={{ marginTop: '-47px' }}>
        <AtlasV2TotalTrafficDonutChart
          loading={isPrimaryLoading}
          organicClicks={primaryData?.organicClicks}
          otherTraffic={primaryData?.otherClicks}
          paidTraffic={primaryData?.adClicks}
          totalClicks={primaryData?.totalClicks}
        />
      </div>
      <Flex>
        <TrafficBarCharts
          loading={isLoading}
          organicTraffic={{
            current: primaryData?.organicClicks,
            comparison: comparisonData?.organicClicks
          }}
          paidTraffic={{
            current: primaryData?.adClicks,
            comparison: comparisonData?.adClicks
          }}
          otherTraffic={{
            current: primaryData?.otherClicks,
            comparison: comparisonData?.otherClicks
          }}
          externalContainerRef={externalContainerRef}
        />
      </Flex>
    </Flex>
  );
};
